module.exports = __webpack_public_path__ + "assets/img/a2.2158422b.png";